var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#F37D53"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3892_393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0001 15C20.3832 15 15 20.3832 15 27.0001C15 33.6169 20.3832 39.0002 27.0001 39.0002C33.6169 39.0002 39.0002 33.6169 39.0002 27.0001C39.0002 20.3832 33.6168 15 27.0001 15ZM27.0001 36.4727C21.7768 36.4727 17.5273 32.2234 17.5273 27.0001C17.5273 21.7768 21.7768 17.5273 27.0001 17.5273C32.2234 17.5273 36.4729 21.7768 36.4729 27.0001C36.4729 32.2234 32.2234 36.4727 27.0001 36.4727Z",
    fill: "#F37D53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6318 28.0872L26.6318 28.0872C26.403 28.011 26.204 27.8647 26.0629 27.6691C25.9219 27.4735 25.8458 27.2385 25.8457 26.9972L25.8457 23.398C25.8457 23.0931 25.9667 22.8006 26.1823 22.585C26.3978 22.3694 26.6902 22.2482 26.995 22.2482C27.2998 22.2482 27.5921 22.3694 27.8077 22.585C28.0232 22.8006 28.1443 23.0931 28.1443 23.398V26.1323V26.1683L28.1786 26.1797L30.9562 27.1023C30.9562 27.1023 30.9562 27.1023 30.9562 27.1023C31.2458 27.1987 31.4853 27.4062 31.6219 27.6792C31.7586 27.9522 31.7813 28.2683 31.6849 28.558C31.5886 28.8477 31.3812 29.0873 31.1083 29.224C30.8354 29.3607 30.5194 29.3833 30.2298 29.287L26.6318 28.0872Z",
    fill: "#F37D53",
    stroke: "white",
    strokeWidth: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3892_393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.63cc5501fe56d696da3889c0b96ab7af.svg";
export { ForwardRef as ReactComponent };